export interface MenuGroupSlotModel {
  id: number
  code: string
  name: string
  referencePrice: string

}

export default class MenuGroupSlot {
  private constructor (
    readonly id: number,
    readonly code: string,
    readonly name: string,
    readonly referencePrice: string
  ) {

  }

  public static createFromModel (data: Partial<MenuGroupSlotModel>): MenuGroupSlot {
    return new MenuGroupSlot(
      data.id!,
      data.code!,
      data.name!,
      data.referencePrice!
    );
  }
}